import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';

const NewSportBenefit = () => {
  const [benefitsTable, setBenefitsTable] = useState([
    { name: '', icon: null, iconPreview: '' },
  ]);
  const [error, setError] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sportId = queryParams.get("sportId");  
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchBenefits = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_SPORT_BENEFIT_VIEW}?sportId=${sportId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-authorization': process.env.REACT_APP_AUTH_TOKEN,
        },
      });

      const data = await response.json();

      if (data.success) {
        const benefits = data.data.benefits.map((benefit) => ({
          id: benefit.benefitId,
          name: benefit.label,
          icon: null,
          iconPreview: benefit.icon,
        }));
        setBenefitsTable(benefits);
      } else {
        setError(`${data.success_message}`)
      }
    } catch (err) {
      console.error('Error fetching sports benefits:', err);
      Swal.fire({
        icon: 'error',
        title: 'Network Error',
        text: 'There was an issue with the network. Please try again later.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };


  useEffect(() => {
    if (sportId) {
      fetchBenefits();
    }
  }, [sportId]);



  const handleBenefitChange = (index, field) => (e) => {
    const newBenefits = [...benefitsTable];
    newBenefits[index][field] = e.target.value;
    setBenefitsTable(newBenefits);
  };

  const handleIconChange = (index) => (e) => {
    const file = e.target.files[0];
    const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];

    if (file && validTypes.includes(file.type)) {
      const newBenefits = [...benefitsTable];
      newBenefits[index].icon = file; 
      newBenefits[index].iconPreview = URL.createObjectURL(file);
      setBenefitsTable(newBenefits);
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Invalid File Type',
        text: 'Please upload a valid image file (PNG, JPG, JPEG, GIF).',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };

  const addBenefitRow = () => {
    setBenefitsTable([...benefitsTable, { name: '', icon: null, iconPreview: '' }]);
  };

  const removeBenefitRow = (index) => {
    const newBenefits = benefitsTable.filter((_, idx) => idx !== index);
    setBenefitsTable(newBenefits);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    for (let i = 0; i < benefitsTable.length; i++) {
      const benefit = benefitsTable[i];
      if (!benefit.name || !(benefit.icon || benefit.iconPreview)) {
        Swal.fire({
          icon: 'error',
          title: 'Missing Fields',
          text: `Benefit ${i + 1} is missing a name or icon. Both are required.`,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        });
        setIsSubmitting(false);
        return;
      }
    }

    const formData = new FormData();


    const benefitsWithIds = benefitsTable.map((benefit) => ({
      benefitId: benefit.id || null, 
      label: benefit.name,
      icon: benefit.icon ? null : benefit.iconPreview, 
    }));

    const formObject = {
      sportId,
      benefits: benefitsWithIds,
    };

    formData.append('form', new Blob([JSON.stringify(formObject)], {
      type: 'application/json'
    }));

    benefitsTable.forEach((benefit, index) => {
      if (benefit.icon) {
        formData.append('benefitIcons', benefit.icon); 
      } else {
        console.log(`No icon selected for Benefit ${index + 1}, sending null.`);
      }
    });

    const formObjectLog = {};
    formData.forEach((value, key) => {
      formObjectLog[key] = value;
    });

    try {
      const response = await fetch(process.env.REACT_APP_API_SPORT_BENEFIT_CREATE, {
        method: 'POST',
        headers: {
          'x-authorization': process.env.REACT_APP_AUTH_TOKEN,
        },
        body: formData,
      });

      const result = await response.json();
      if (response.ok) {
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: result.message || 'Sport benefits have been updated successfully.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        });
        fetchBenefits();
        setEditMode(false);
            setIsSubmitting(false);
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: result.message || 'Something went wrong!',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        });
        setIsSubmitting(false);
      }
    } catch (error) {
      console.error('Error:', error);
      Swal.fire({
        icon: 'error',
        title: 'Network Error',
        text: 'There was an issue with the network. Please try again later.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
    } finally {
      setIsSubmitting(false);
    }
  };


  const toggleEditMode = () => {
    setError('')
    if (editMode) {
      fetchBenefits();
      setError('')
    }
    setEditMode((prev) => !prev);
  };


  return (
    <div className="enrollment-container">
      <div className="search-bar">
        <div className="breadcrumb">
          <Link to="/sportList" className="breadcrumb-link">Sport List</Link> &gt; Create Benefit
        </div>
        <button
          style={{ background: '#209978' }}
          type="button"
          onClick={toggleEditMode}
          className="edit-button"
        >
          {editMode ? (
            <>
              <svg
                viewBox="0 0 512 512"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                fill="white"
                stroke="white"
                width="18"
                height="18"
              >
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <title>cancel</title>
                  <g
                    id="Page-1"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <g id="work-case" fill="white" transform="translate(91.52, 91.52)">
                      <polygon
                        id="Close"
                        points="328.96 30.2933333 298.666667 1.42108547e-14 164.48 134.4 30.2933333 1.42108547e-14 1.42108547e-14 30.2933333 134.4 164.48 1.42108547e-14 298.666667 30.2933333 328.96 164.48 194.56 298.666667 328.96 328.96 298.666667 194.56 164.48"
                      ></polygon>
                    </g>
                  </g>
                </g>
              </svg>
            </>
          ) : (
            <>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="none"
                viewBox="0 0 24 24"
                stroke="white"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M16.862 3.487a2.12 2.12 0 0 1 3.001 3.001L7.5 18.85l-4 1 1-4L16.862 3.487z"
                />
              </svg>
            </>
          )}
        </button>

      </div>
      {error && <div className="error-message">{error}</div>}
      {!error && (
        <div style={{ overflow: 'scroll' }}>
          <fieldset className="enrollment-form-fieldset enrollment-form-mt-3">
            <legend className="enrollment-form-legend">Sport Benefits</legend>
            <table className="rental-entry-table">
              <thead>
                <tr>
                  <th>Benefit Title</th>
                  {editMode && <th>Icon</th>}
                  <th>Preview</th>
                  {editMode && <th>Action</th>}
                </tr>
              </thead>
              <tbody>
                {benefitsTable.map((row, idx) => (
                  <tr key={idx}>
                    <td>
                      <input
                        type="text"
                        className="rental-input"
                        value={row.name}
                        onChange={handleBenefitChange(idx, 'name')}
                        placeholder="Enter benefit title"
                        maxLength={25}
                        disabled={!editMode}
                      />
                    </td>
                    {editMode && (
                      <td>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                          <input
                            type="file"
                            id={`benefit-icon-${idx}`}
                            accept="image/*"
                            style={{ display: 'none' }}
                            className="rental-input"
                            onChange={handleIconChange(idx)} 
                          />
                          <button
                            type="button"
                            style={{ padding: '4px 10px', border: 'none', background: '#eaf4ff' }}
                            onClick={() => document.getElementById(`benefit-icon-${idx}`).click()}
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20">
                              <path
                                fill="black"
                                d="M19,13a1,1,0,0,0-1,1v.38L16.52,12.9a2.79,2.79,0,0,0-3.93,0l-.7.7L9.41,11.12a2.85,2.85,0,0,0-3.93,0L4,12.6V7A1,1,0,0,1,5,6h7a1,1,0,0,0,0-2H5A3,3,0,0,0,2,7V19a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V14A1,1,0,0,0,19,13ZM5,20a1,1,0,0,1-1-1V15.43l2.9-2.9a.79.79,0,0,1,1.09,0l3.17,3.17,0,0L15.46,20Zm13-1a.89.89,0,0,1-.18.53L13.31,15l.7-.7a.77.77,0,0,1,1.1,0L18,17.21ZM22.71,4.29l-3-3a1,1,0,0,0-.33-.21,1,1,0,0,0-.76,0,1,1,0,0,0-.33.21l-3,3a1,1,0,0,0,1.42,1.42L18,4.41V10a1,1,0,0,0,2,0V4.41l1.29,1.3a1,1,0,0,0,1.42,0A1,1,0,0,0,22.71,4.29Z"
                              />
                            </svg>
                          </button>
                          {row.icon && (
                            <span style={{ fontSize: '12px', marginTop: '4px' }}>
                              {row.icon.name}
                            </span>
                          )}
                        </div>
                      </td>
                    )}
                    <td>
                      {row.iconPreview ? (
                        <img
                          src={row.iconPreview}
                          alt="Icon Preview"
                          style={{ width: 40, height: 40 }}
                        />
                      ) : (
                        <span>No Preview</span>
                      )}
                    </td>
                    {editMode && (
                      <td>
                        <button
                          type="button"
                          className="enrollment-form-button enrollment-form-button-danger"
                          onClick={() => removeBenefitRow(idx)}
                          disabled={benefitsTable.length === 1}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="white" strokeWidth="2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 7h12M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M10 11v6M14 11v6M5 7h14l-1 12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 7z" />
                          </svg>
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>

            </table>
            {editMode && (
              <button type="button" className="plusButton" onClick={addBenefitRow} title="Add Benefit">
                <svg className="plusIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                  <g>
                    <path d="M13.75 23.75V16.25H6.25V13.75H13.75V6.25H16.25V13.75H23.75V16.25H16.25V23.75H13.75Z"></path>
                  </g>
                </svg>
              </button>
            )}
          </fieldset>

          <div className="enrollment-form-section enrollment-form-mt-3">
            <button
              className="submit-button"
              type="submit"
              onClick={handleSubmit}
              disabled={isSubmitting}
              style={{
                display: editMode ? 'block' : 'none',
                cursor: isSubmitting ? 'not-allowed' : 'pointer',
                opacity: isSubmitting ? 0.6 : 1,
              }}
            >
              {isSubmitting ? 'Submitting...' : 'Submit'}
            </button>

          </div>
        </div>
      )}
    </div>
  );
};

export default NewSportBenefit;
